export default "__VITE_ASSET__CHOpL_cv__"